export default __webpack_public_path__ + "static/media/centro_microcentro_sarmiento.90ccc608.jpg";